import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import dict from "../i18n/es-MX";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, message: "" };
    }

    static getDerivedStateFromError(err) {
        return { hasError: true, message: (err && err.message) || "Unknown error" };
    }

    componentDidCatch(error, info) {
        // Log to console for devtools; production could ship to a remote logger here.
        // eslint-disable-next-line no-console
        console.error("[ErrorBoundary] component crashed:", error, info?.componentStack);
    }

    render() {
        if (!this.state.hasError) return this.props.children;

        const t = dict?.errorBoundary || {};
        const title = t.title || "Algo salió mal";
        const description = this.props.description || t.descriptionRegistro || t.description || "Ocurrió un error al cargar esta pantalla. Intenta refrescar la página o contacta a soporte.";
        const refresh = t.refresh || "Refrescar";
        const back = t.back || "Volver atrás";

        return (
            <div data-testid="error-boundary" className="min-h-[60vh] flex items-center justify-center px-4 py-10">
                <div className="max-w-md w-full rounded-2xl border border-red-500/40 bg-red-500/5 p-6 space-y-4">
                    <div className="flex items-center gap-3 text-red-300">
                        <AlertTriangle size={22}/>
                        <h2 className="font-display text-2xl font-extrabold">{title}</h2>
                    </div>
                    <p className="text-sm text-slate-200 leading-relaxed">{description}</p>
                    {this.state.message && (
                        <details className="text-xs text-slate-500">
                            <summary className="cursor-pointer hover:text-slate-300">{t.details || "Detalles técnicos"}</summary>
                            <pre className="mt-2 whitespace-pre-wrap break-all font-mono text-[10px] text-slate-400 bg-slate-950/60 p-2 rounded">{this.state.message}</pre>
                        </details>
                    )}
                    <div className="flex gap-2 pt-2">
                        <button
                            type="button"
                            data-testid="error-boundary-refresh"
                            onClick={() => window.location.reload()}
                            className="h-10 px-4 rounded-lg bg-brand-orange hover:bg-orange-400 text-slate-950 font-semibold uppercase text-xs tracking-wider inline-flex items-center gap-2"
                        >
                            <RefreshCw size={14}/>{refresh}
                        </button>
                        <button
                            type="button"
                            data-testid="error-boundary-back"
                            onClick={() => { window.history.length > 1 ? window.history.back() : (window.location.href = "/"); }}
                            className="h-10 px-4 rounded-lg border border-slate-700 hover:bg-slate-800 text-slate-200 text-xs uppercase tracking-wider"
                        >
                            {back}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
